module.exports = __webpack_public_path__ + "static/media/dog-transparent.b6514a74.png";